import config from 'lib/config'
import Head from 'next/head'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { configureClarityPrivacy } from 'stories/utils/clarity'

const MicrosoftClarityTag = () => {
    const tag = config.getMicrosoftClarityTag()
    const router = useRouter()

    useEffect(() => {
        const timer = setTimeout(() => {
            configureClarityPrivacy()
        }, 100)

        return () => {
            clearTimeout(timer)
        }
    }, [])

    // Handle Next.js router changes
    useEffect(() => {
        const handleRouteChange = (_: string) => {
            setTimeout(() => {
                configureClarityPrivacy()
            }, 100)
        }

        router.events.on('routeChangeComplete', handleRouteChange)

        return () => {
            router.events.off('routeChangeComplete', handleRouteChange)
        }
    }, [router.events])

    return (
        <Head>
            <script
                type="text/javascript"
                dangerouslySetInnerHTML={{
                    __html: `
                    (function(c,l,a,r,i,t,y){
                        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                        
                        // Configure privacy settings after Clarity initialization
                        c[a]('set', 'maskAllText', false);
                        c[a]('set', 'maskAllInputs', true);
                        c[a]('set', 'maskSensitiveInputs', true);
                        
                    })(window, document, "clarity", "script", "${tag}");                
                `,
                }}
            />
        </Head>
    )
}

export default MicrosoftClarityTag
